<template>
  <div id="KenshinJudgmentDetail">
    <div id="container-center">
      <div class="labelTitle lable">検診結果詳細</div>
      <div class="button-area">
        <b-button
         class="postion-left is-primary"                
         icon-left="chevron-double-left"
         :disabled="resultList.length==1"
         @click.prevent="Backward">前の判定へ
        </b-button>
        <b-button
         class="postion-left is-primary"
         icon-right="chevron-double-right"
         :disabled="resultList.length==1"
         @click.prevent="Forward">次の判定へ
        </b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens" class="judgment-area">
        <div class="card-content margin-top">
          <span style="font-size:20px;">{{kind}} 測定結果</span>
          <table id="KenshinJudgmentDetailTable" v-if="kind.indexOf('ウォッチパット')!=-1">
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>開始日</th><td>{{data.startDate}}</td><th>SPO2最低</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>開始時間</th><td>{{data.startTime}}</td><th>脈拍平均</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>終了日</th><td>{{data.endDate}}</td><th>脈拍最低</th><td>{{data.pulseLowest}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>終了時間</th><td>{{data.endTime}}</td><th>酸素90未満</th><td>{{data.oxygenLess90}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>酸素88未満</th><td>{{data.oxygenLess88}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>睡眠時間</th><td>{{data.sleepTime}}</td><th>酸素85未満</th><td>{{data.oxygenLess85}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>ODI4</th><td>{{data.odi4}}</td><th>酸素80未満</th><td>{{data.oxygenLess80}}</td></tr>
            <tr><th>体重</th><td>{{data.weight}}</td><th>RDI</th><td>{{data.rdi}}</td><th>酸素70未満</th><td>{{data.oxygenLess70}}</td></tr>
            <tr><th>BMI</th><td>{{data.bmi}}</td><th>AHI</th><td>{{data.ahi}}</td><th>いびき40dB率</th><td>{{data.snoring40dBRate}}</td></tr>
            <tr><th>検査ID</th><td>{{data.inspectionId}}</td><th>SPO2中央</th><td>{{data.SPO2Center}}</td><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr>
              <th>解析レポート</th>
              <td colspan="5">
                <ul class="report-list">
                  <li v-for="(report,index) in data.analysisResultFileList" :key="index">
                    <a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.fileName}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
          <table id="KenshinJudgmentDetailTable" v-else-if="kind.indexOf('サイモンJ')!=-1">
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>体重</th><td>{{data.weight}}</td><th>ODI3</th><td>{{data.odi3}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>BMI</th><td>{{data.bmi}}</td><th>SPO2平均値</th><td>{{data.SPO2Center}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>患者ID</th><td>{{data.inspectionId}}</td><th>SPO2最低値</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>測定日</th><td>{{data.startDate}}</td><th>SPO2低下数</th><td>{{data.SPO2Declines}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>開始時刻</th><td>{{data.startTime}}</td><th>脈拍平均</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>解析時間</th><td>{{data.analysisTime}}</td></tr>
            <tr>
              <th>解析レポート</th>
              <td colspan="5">
                <ul class="report-list">
                  <li v-for="(report,index) in data.analysisResultFileList" :key="index">
                    <a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.fileName}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
          <table id="KenshinJudgmentDetailTable" v-else>
            <!-- WP以外用表示テーブル -->
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td><th>BMI</th><td>{{data.bmi}}</td><th>ODI4</th><td>{{data.odi4}}</td></tr>
            <tr><th>社員番号</th><td>{{data.employeeNumber}}</td><th>検査ID</th><td>{{data.inspectionId}}</td><th>ODI3</th><td>{{data.odi3}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td><th>開始日</th><td>{{data.startDate}}</td><th>ODI2</th><td>{{data.odi2}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td><th>開始時間</th><td>{{data.startTime}}</td><th>SPO2中央</th><td>{{data.SPO2Center}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td><th>終了日</th><td>{{data.endDate}}</td><th>SPO2最低</th><td>{{data.SPO2Minimum}}</td></tr>
            <tr><th>年齢</th><td>{{data.age}}</td><th>終了時間</th><td>{{data.endTime}}</td><th>脈拍中央</th><td>{{data.pulseAverage}}</td></tr>
            <tr><th>身長</th><td>{{data.height}}</td><th>測定時間</th><td>{{data.measurementTime}}</td><th>&lt;90%時間</th><td>{{data.lessThan90Time}}</td></tr>
            <tr><th>体重</th><td>{{data.weight}}</td><th>睡眠時間</th><td>{{data.sleepTime}}</td><th>&lt;90%割合</th><td>{{data.lessThan90Ratio}}</td></tr>
            <tr><th>セルフチェック</th><td>{{data.selfCheck}}</td></tr>
            <tr>
              <th>解析レポート</th>
              <td colspan="5">
                <ul class="report-list">
                  <li v-for="(report,index) in data.analysisResultFileList" :key="index">
                    <a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.fileName}}</a></li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">判定入力</span>
          <table>
            <tr>
              <th></th><td>
                <span v-if="kind.indexOf('ウォッチパット')!=-1">A：正常範囲 B：要観察 C：要精密検査 Z：要治療 R：判定不能 </span>
                <span v-else>A：正常範囲 B：要観察 C：要精密検査 R：判定不能</span>
              </td>
            </tr>
            <tr>
              <th><span class="fontSize20">判定</span><span class="require"/></th>
              <td><select class="fontSize20" v-model="data.judgment" id="judgment">
                <template v-if="kind.indexOf('ウォッチパット')!=-1">
                  <option></option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="Z">Z</option><option value="R">R</option>
                </template>
                <template v-else>
                  <option></option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="R">R</option>
                </template>
              </select></td>
            </tr>
            <tr>
              <th><span class="fontSize20">所見</span></th>
              <td>
                <select style="margin-bottom:5px;" v-model="data.findings" @input="commentSelectInput">
                  <option value="0">所見なし</option>
                  <option value="1">測定時間の不足のため判定不可</option>
                  <option value="2">センサー外れのため判定不可</option>
                  <option value="3">その他</option>
                </select>
                <textarea class="noresize" v-model="data.findingsMemo" maxlength="256"></textarea>
              </td>
            </tr>
          </table>
          <div class="button-area">
            <b-button class="is-primary" icon-left="content-save-outline" @click="save">保存</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KenshinJudgmentDetail",
  methods: {
    Backward: function(){
        document.getElementById("judgment").style["border-color"] = "";
        if(this.index == 0){
            this.index = this.resultList.length - 1;
        } else {
            this.index = this.index -1;
        }
        this.data = this.resultList[this.index];
    },
    Forward: function(){
        document.getElementById("judgment").style["border-color"] = "";
        if(this.index == this.resultList.length - 1){
            this.index = 0;
        } else {
            this.index = this.index + 1;
        }
        this.data = this.resultList[this.index];
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    save: function(){
        document.getElementById("judgment").style["border-color"] = "";
        if(!this.data.judgment){
            // 判定は"必須"
            this.showErrorMessage("判定は必須項目です。")
            document.getElementById("judgment").style["border-color"] = "red";
            return
        }
        var excuteApi = this.setKenshinJudgmentSavePOST;
        var successCallBack = this.setKenshinJudgmentSavePOSTSuccess;
        var errorCallBack = this.setKenshinJudgmentSavePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinJudgmentSavePOST: function(client) {
      var obj = {
        id:this.data.id,
        receiptNumber:this.data.receiptNumber,
        judgment:this.data.judgment,
        findings:this.data.findings,
        findingsMemo:this.data.findingsMemo
      }
      return client.apis.externalKenshinJudgment.setKenshinJudgmentSavePOST({
        body:obj
      });
    },
    setKenshinJudgmentSavePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
    },
    setKenshinJudgmentSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    commentSelectInput: function(event){
      var inputLabel = event.srcElement[event.srcElement.selectedIndex]
      if (inputLabel.label != "その他") {
       this.data.findingsMemo = inputLabel.label;
      } else {
        this.data.findingsMemo = "";
      }
    },
    back: function(){
    this.$router.push({
        name: "KenshinJudgment",
        params: { searchConditions: this.searchParams, doctorName:this.doctorName, result:this.resultList,kind:this.kind},
      });
    },
  },
  data() {
    var kind = this.$route.params["kind"];
    var index = this.$route.params["index"];
    var resultList = this.$route.params["result"];
    var searchParams = this.$route.params["searchConditions"];
    var doctorName = this.$route.params["doctorName"];
    console.log(doctorName)
    var data = resultList[index];
    return {
        kind: kind,
        index,
        resultList,
        data,
        searchParams,
        doctorName
    };
  },
  filters: {},
  components: {
  },
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.postion-left {
    float:left;
    margin-left:10px;
}
.fontSize20 {
    font-size: 20px;
}

table#KenshinJudgmentDetailTable tr th {
  width: 10% !important;
}
table#KenshinJudgmentDetailTable tr td {
  word-break : break-all !important;
  width: 20% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/KenshinJudgmentDetail.vue